import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/schedule";

export async function getUserQueries() {
  const response = await instance.get(`/get_queries`);
  return response.data;
}

export async function createUserQuery(newQuery) {
  const response = await instance.post(`/create_query`, newQuery);
  return response.data;
}

export async function editUserQuery(editQuery) {
  const response = await instance.post(`/edit_query`, editQuery);
  return response.data;
}

export async function deleteUserQuery(query_id) {
  const response = await instance.post(`/delete_query`, { query_id });
  return response.data;
}
